import React, { FC, useCallback } from 'react';
import { useTranslation } from '../../utils/useTranslation';
import { SmartDrawer } from '../feedback/SmartDrawer';
import { Button } from '../input/Button';
import { DataTestId } from '../layout/DataTestIdWrapper';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';

interface DeleteFromCollectionDrawerProps {
    onDeletePostFromDefaultCollection: () => void;
    onDeletePostFromCollection: () => void;
    handleClose: () => void;
}

export const DeleteFromCollectionDrawer: FC<DeleteFromCollectionDrawerProps> = ({
    onDeletePostFromDefaultCollection,
    onDeletePostFromCollection,
    handleClose,
}) => {
    const t = useTranslation();

    const onClose = useCallback(() => {
        handleClose();
    }, [handleClose]);

    return (
        <SmartDrawer
            onClose={onClose}
            titleContent={
                <>
                    <Typography variant="title2" weight="bold" mx="auto">
                        {t('Отменить сохранение поста?')}
                    </Typography>
                </>
            }
            mainContent={
                <>
                    <Typography variant="body" opacity="0.8">
                        {t(
                            'Выбирая вариант «Везде», вы отмените сохранение поста из коллекции и из избранного.',
                        )}
                    </Typography>
                    <Flex
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        pt={4}
                    >
                        <Button
                            width="45%"
                            size="m"
                            onClick={onDeletePostFromCollection}
                            dataTestId={DataTestId.ONLY_IN_COLLECTION}
                        >
                            {t('Только в коллекции')}
                        </Button>
                        <Button
                            width="45%"
                            size="m"
                            onClick={onDeletePostFromDefaultCollection}
                            dataTestId={DataTestId.EVERYWHERE}
                        >
                            {t('Везде')}
                        </Button>
                    </Flex>
                </>
            }
        />
    );
};
